"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var config = _interopRequireWildcard(require("@8x8/oxygen-config"));

var _templateObject;

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var TooltipWrapper = _styledComponents["default"].div.attrs(function (_ref) {
  var testId = _ref.testId;
  return Object.assign({}, config.getTestAttributes(testId));
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  background-color: ", ";\n  border: ", ";\n  border-radius: ", ";\n  box-sizing: border-box;\n  box-shadow: ", ";\n  color: ", ";\n  font-family: ", ";\n  font-size: ", ";\n  font-weight: normal;\n  font-style: normal;\n  font-stretch: normal;\n  line-height: ", ";\n  letter-spacing: normal;\n  margin: 0;\n  max-height: ", ";\n  max-width: ", ";\n  padding: ", ";\n  position: relative;\n  z-index: ", ";\n  ", ";\n"])), function (_ref2) {
  var theme = _ref2.theme;
  return theme.backgroundColor;
}, function (_ref3) {
  var theme = _ref3.theme;
  return "".concat(theme.borderWidth, " ").concat(theme.borderStyle, " ").concat(theme.borderColor);
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.borderRadius;
}, function (_ref5) {
  var theme = _ref5.theme;
  return theme.boxShadow;
}, function (_ref6) {
  var theme = _ref6.theme;
  return theme.color;
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.fontFamily;
}, function (_ref8) {
  var theme = _ref8.theme;
  return theme.fontSize;
}, function (_ref9) {
  var theme = _ref9.theme;
  return theme.lineHeight;
}, function (_ref10) {
  var theme = _ref10.theme;
  return theme.maxHeight;
}, function (_ref11) {
  var theme = _ref11.theme;
  return theme.maxWidth;
}, function (_ref12) {
  var theme = _ref12.theme;
  return theme.padding;
}, function (_ref13) {
  var theme = _ref13.theme;
  return theme.zIndex;
}, function (_ref14) {
  var theme = _ref14.theme;
  return theme.animation;
});

var _default = TooltipWrapper;
exports["default"] = _default;